import { render, staticRenderFns } from "./LabStorageBase.vue?vue&type=template&id=dbdd2d42&"
import script from "./LabStorageBase.vue?vue&type=script&lang=js&"
export * from "./LabStorageBase.vue?vue&type=script&lang=js&"
import style0 from "./LabStorageBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports